import React, { useEffect, useState } from "react";
import { validateRadioSepelio, validatePlans } from "../../Utils/validators";
import ErrorCustom from "../errorCustom";
import RadioButtonsGroup from "../radioButtonsGroup";
import InputNumber from "../inputNumber";
import NumberFormat from "react-number-format";

const FormRgDinamyc = ({ clearError, data, register, handleOnChange, setValue, handleChangeRadius, currency, errors, useRoll}: any) => {

    const findControlsToUpdate = (value: any, changeDetection: boolean, changeInputs: any[]): void => {
        if(changeDetection && changeInputs.hasOwnProperty(value)){
            handleOnChange(changeInputs[value]);
        }else{
            handleOnChange([]);
        }
    }

    const validateAmounth = (isRequired: boolean, formConrol: string, value: any, min: any, max: any, errorMessage: string, isEnable: boolean) => {
      if(isRequired && formConrol && errorMessage) {
        if (!Number.isInteger(parseInt(value))){
          return "Debe ingresar un número";
        }
        else if (!(BigInt(value) >= min && BigInt(value) <= max)){
          return errorMessage;
        }
        else{
          clearError(formConrol)
          return true
        }
      }else {
        if(Number.isInteger(parseInt(value)) && isEnable){
          if ( !(BigInt(value) >= min && BigInt(value) <= max)){
            return errorMessage;
          }
          else{
            clearError(formConrol)
            return true
          }
        }
      }
    };

  return (
    <>
    {data.map((item: any, index: number) => 
        <>
        { item.questionType === 'select' && item.metadata.isVisible && item.metadata.setting.rollsEnabled.includes(useRoll.toUpperCase()) && (
            <div className="vasForm__form__input-container-select">
                <label>{item.metadata.setting.label}</label>
                <select className="browser-default" 
                    id={item.metadata.formControlName}
                    name={item.metadata.formControlName}
                    onChange={(e) => findControlsToUpdate(e.target.value, item.metadata.setting.changeDetection, item.metadata.setting.updateInput )}
                    ref={register({ validate: validatePlans })}
                  >
                    <option selected disabled value="">
                            Selecciona un { item.metadata.setting.label }
                        </option>
                    { item.metadata.setting.options.map((option: any, key: any) => (
                        <>
                        { option.active && option.rollsEnabled.includes(useRoll.toUpperCase()) && (<option selected={option.selected} key={key} value={option.value}>
                            { option.label }
                        </option>)}
                        </>
                    ))}
                </select>
                <ErrorCustom errors={errors} name={item.metadata.formControlName} />
            </div>
        )}
        { item.questionType === 'checkbox' && item.metadata.isVisible && (
             <div className="vasForm__form__input-container-dps-counter__portafolio">
             <label>{ item.metadata.setting.label }</label>
             <div className="vasForm__form__input-container-dps-counter__portafolio__container">
               <RadioButtonsGroup
                 name={item.metadata.formControlName}
                 register={register({ validate: (value: any) => validateRadioSepelio(value, item.metadata.isRequire) })}
                 disabled={!item.metadata.isEnable}
                 setDps={(e: any) => handleChangeRadius(item, e)}
                 setChecked={(e: any) => {}}
                 checked={item.metadata.checked}
                 id={item.metadata.formControlName}
               />
               { item.metadata.checked  && 
              <NumberFormat
                  {...register('montoSepelioCantidad')}
                  name={'montoSepelioCantidad'}
                  ref={register}
                  prefix={currency === "USD" ? "$ " : "S/ "}
                  thousandSeparator={true}
                  allowNegative={false}
                  defaultValue={0}
                  value={ item.metadata.defaulValue > 0 && currency === "USD" ? 1500 : item.metadata.defaulValue > 0 && currency === "PEN" ? 5000 : null }
                  disabled={!item.metadata.isEnable}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  isNumericString={true}
                  autoComplete="false"
                  onValueChange={(values: any) => {
                    const { value } = values;
                    setValue('montoSepelioCantidad', Number(value));
                  }}
                />
                }
                
             </div>
             <ErrorCustom errors={errors} name={item.metadata.formControlName} />
           </div>
        )}
        { item.questionType === 'inputNumber' && item.metadata.setting.rollsEnabled.includes(useRoll.toUpperCase()) && item.metadata.isVisible && (
            <div className="vasForm__form__input-container-select">
            <label>{ item.metadata.setting.label }</label>
              <InputNumber
           
                nameVal={item.metadata.formControlName}
                setValue={setValue}
                register={register}
                disabled={!item.metadata.isEnable}
                prefix={item.metadata.prefix ? item.metadata.prefix : '' }
                suffix={item.metadata.suffix ? item.metadata.suffix : '' }
                init={0}
                validatorInput={(value: any) => validateAmounth(item.metadata.isRequire, item.metadata.formControlName, value, item.metadata.setting.min, item.metadata.setting.max, item.metadata.setting.errorMessage, item.metadata.isEnable)}
                
          />
           <ErrorCustom errors={errors} name={item.metadata.formControlName} />
          </div>
        ) }
        { item.questionType === 'inputNumberSimple' && item.metadata.setting.rollsEnabled.includes(useRoll.toUpperCase()) && item.metadata.isVisible && (
            <div className="vasForm__form__input-container-select">
            <label>{ item.metadata.setting.label }</label>
              <input
                ref={register}
                defaultValue={0}
                name={item.metadata.formControlName}
                disabled={!item.metadata.isEnable}
              />

           <ErrorCustom errors={errors} name={item.metadata.formControlName} />
          </div>
        ) }
        </>
    )}
    </>
  );
};

export default FormRgDinamyc;